const styles = theme => ({	
	root: {
		display: 'flex',
	},
});

export default styles;